var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bdc2d4;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.109,150.666c0,56.684-42.216,103.662-97.477,112.2V183.512h26.879l5.139-32.846H168.632V129.39c0-8.929,4.427-17.7,18.815-17.7h14.547V83.733a177.641,177.641,0,0,0-25.851-2.252c-26.406,0-43.64,15.763-43.64,44.182v25h-29.33v32.846H132.5v79.357c-55.261-8.541-97.557-55.519-97.557-112.2C34.946,88,86.729,37.144,150.528,37.144,214.406,37.144,266.109,88,266.109,150.666Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b81b8a103bcc25cd4e0cbfbe2fd43ac7.svg";
export { ForwardRef as ReactComponent };